import React from 'react';
import { SceneState, useSceneStore } from '../../state/sceneStore';

const PointCloudLoadStatus: React.FC = () => {
  const pointCloudVisible = useSceneStore((state: SceneState) => state.pointCloudVisible);
  const pendingIds = useSceneStore((state: SceneState) => state.cloudLoadPendingIds);
  const readyIds = useSceneStore((state: SceneState) => state.cloudLoadReadyIds);
  const designCloudLoadError = useSceneStore((state: SceneState) => state.designCloudLoadError);
  const requestDesignCloudReload = useSceneStore((state: SceneState) => state.requestDesignCloudReload);

  if (!pointCloudVisible) {
    return null;
  }

  if (designCloudLoadError) {
    return (
      <div style={{
        position: 'absolute',
        top: '20px',
        left: '20px',
        background: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        padding: '15px',
        borderRadius: '8px',
        minWidth: '300px',
        zIndex: 1000,
      }}>
        <div style={{ marginBottom: '10px', color: '#ff8a80' }}>
          {designCloudLoadError}
        </div>
        <button
          type="button"
          onClick={() => requestDesignCloudReload()}
          style={{
            background: '#4CAF50',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            padding: '8px 12px',
            cursor: 'pointer',
          }}
        >
          Retry
        </button>
      </div>
    );
  }

  if (pendingIds.length === 0) {
    return null;
  }

  const total = pendingIds.length + readyIds.length;
  const ready = readyIds.length;
  const progress = total === 0 ? 0 : Math.round((ready / total) * 100);

  return (
    <div style={{
      position: 'absolute',
      top: '20px',
      left: '20px',
      background: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      padding: '15px',
      borderRadius: '8px',
      minWidth: '300px',
      zIndex: 1000,
      pointerEvents: 'none',
    }}>
      <div style={{ marginBottom: '5px' }}>
        {`Loading clouds: ${ready} / ${total}`}
      </div>
      <div style={{
        width: '100%',
        height: '8px',
        background: '#333',
        borderRadius: '4px',
        overflow: 'hidden',
      }}>
        <div style={{
          width: `${progress}%`,
          height: '100%',
          background: '#4CAF50',
          transition: 'width 0.3s ease',
        }} />
      </div>
    </div>
  );
};

export default PointCloudLoadStatus;
